<div id="<%= dom_id payment %>" class="w-full sm:w-auto my-5 space-y-5">
  <div>
    <strong class="block font-medium mb-1">Person:</strong>
    <%= payment.person_id %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Amount:</strong>
    <%= payment.amount %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Date:</strong>
    <%= payment.date %>
  </div>
  <div>
    <strong class="block font-medium mb-1">Comment:</strong>
    <%= payment.comment %>
  </div>
</div>
